import { Injectable } from '@angular/core';
import { EncryptionHelper } from '@core/helpers/encryption.helper';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class StorageService {
  constructor(private cookie: CookieService) {}

  async get(key: any): Promise<any> {
    const hashKey = await EncryptionHelper.hash(key);
    const data = localStorage.getItem(hashKey);
    if (!data) return null;
    return await EncryptionHelper.decrypt(data);
  }

  async set(key: any, val: any): Promise<void> {
    const hashKey = await EncryptionHelper.hash(key);
    const encryptedData = await EncryptionHelper.encrypt(val);
    localStorage.setItem(hashKey, encryptedData);
  }

  async remove(key: any): Promise<void> {
    const hashKey = await EncryptionHelper.hash(key);
    localStorage.removeItem(hashKey);
  }
}
